// Import Crypto
import { enumNumberMember } from '@babel/types'
import CryptoJS from 'crypto-js'


export function base64url( source:any ) {
  let encodedSource = CryptoJS.enc.Base64.stringify(source)
  encodedSource = encodedSource.replace(/=+$/, '')
  encodedSource = encodedSource.replace(/\+/g, '-')
  encodedSource = encodedSource.replace(/\//g, '_')
  return encodedSource
}


export function stringifyEncrypt( dataToEncrypt:any ) {
  const stringifiedData = CryptoJS.enc.Utf8.parse( JSON.stringify( dataToEncrypt ) )
  const encodedData = base64url( stringifiedData )
  return encodedData
}


export function createJWT( data:any, wordSecret:any = null ) {

  const headerData = {
    "alg": "HS256",
    "typ": "JWT"
  }

  // const secret = wordSecret || window.drupalSettings.tab014k453nx
  const secret = wordSecret || 'tab014k453nx'

  const encodedHeader = stringifyEncrypt( headerData )
  const encodedData = stringifyEncrypt( data )

  let signature:any = encodedHeader + "." + encodedData
  signature = CryptoJS.HmacSHA256(signature, secret)
  signature = base64url(signature)

  const finalJWT = encodedHeader + '.' + encodedData + '.' + signature

  return finalJWT
}

